import {PASearch} from "../PA.Core/PASearch";
import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Customer_Type_Search_Fields: { [id:string]: ISearchProviderField } = {
    WB_CUSTM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'WB CustomerType Id', columnResourceName: 'colWBCustomerTypeId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    CUSTM_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'ID', columnResourceName: 'colCustomerTypeId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    CUSTM_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Name', columnResourceName: 'colCustomerTypeName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colCustomerTypeMDSet', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    }
};

const CustomerTypeSearchProviderBasis: ISearchProvider = {
    keyFields: {
        id: 'WB_CUSTM_ID',
        id_ui: 'CUSTM_ID',
        name: 'CUSTM_NAME'
    },

    searchProviderFields: vUI_Customer_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            const findRequest = SearchUtils.makeSearchRequest(
                searchOptions,
                'vUI_Customer_Type_Search',
                this.searchProviderFields,
                []
            );

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
};

const CustomerTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "CustomerTypeSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'ID', searchProviderFieldId: 'CUSTM_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'CUSTM_NAME', renderOptions: {} },
        { profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', renderOptions: {} },
    ], // ISearchFields
    profileDisplayFields: [
        'CUSTM_ID', 'CUSTM_NAME','MDSET_NAME'
    ], // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerTypeSearchProviderBasis,

    profileSortIdDefault: "",
    profileSorts: []
};

const CustomerTypeSearch: ISearch = {
    searchName: "Find Customer Type",
    renderOptions: { ui5ResourceId: "CustomerTypeSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [CustomerTypeSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("CustomerTypeBO","CustomerType", CustomerTypeSearch, "Customer Type Search")
export { CustomerTypeSearch };
